import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
    credentials: Cookies.get("credentials") ? JSON.parse(Cookies.get("credentials")) : null
};

const credentialsSlice = createSlice({
    name: "credentialsSlice",
    initialState,
    reducers: {
        setCredentials: (state, action) => {
            state.credentials = action.payload;
            Cookies.set("credentials", JSON.stringify(action.payload), { expires: 6 });
            return state;
        },
        removeCredentials: (state, action) => {
            state.credentials = null;
            Cookies.remove("credentials");
            return state;
        }
    }
})

export const { setCredentials , removeCredentials } = credentialsSlice.actions;
export default credentialsSlice;